import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../api/client";
import { customDateFormatType2, formatNumber } from "../utils/utils";
import { formatDateDb } from "../utils/tools";
import { NumberOfPerPage } from "../utils/globalVariable";
import { useState } from "react";
const NUMBER_NFT_PER_PAGE = NumberOfPerPage.commissionReport;

const queryKey = "commissionAnalyst";

async function fetchSalesManagement(currentPage, search, startTime, endTime) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (startTime) options.startTime = customDateFormatType2(startTime);
    if (endTime) options.endTime = customDateFormatType2(endTime);

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/commissionAnalyst?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );
    
    const newData = data?.items.map((item, index) => {
      return {
        code: item?.employeeObject?.code || "-",
        name: item?.employeeObject?.fullName || "-",
        jobPosition: item?.employee?.jobPosition?.name || "-",
        countLockingParticipant: item?.countContract || "0",
        countLockingApprove: item?.contractCountWithServiceFee || "0",
        totalValue: item?.listedPrice
          ? `${formatNumber(item?.listedPrice)} VNĐ`
          : "0 VNĐ",
        amountPay: item?.totalPriceCommission
          ? `${formatNumber(item?.totalPriceCommission)} VNĐ`
          : "0 VNĐ",
        amountReceive: item?.amountDisbursement
          ? `${formatNumber(item?.amountDisbursement)} VNĐ`
          : "0 VNĐ",
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useSalesManagement(search, startTime, endTime) {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, currentPage, search, startTime, endTime],
    queryFn: () => fetchSalesManagement(currentPage, search, startTime, endTime),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });


  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    commissionAnalystData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}

async function fetchSalesManagementDetail(search, startTime, endTime, employeeId) {
  try {
    const options = {};

    if (startTime) options.startTime = customDateFormatType2(startTime);
    if (endTime) options.endTime = customDateFormatType2(endTime);
    if(employeeId) options.employeeId = employeeId;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/commission/getDetailByLocking?${queryParams}`);
    
    const newData = data?.items.map((item, index) => {
      return {
        bookingTime: item?.bookingTime ? formatDateDb(item?.bookingTime) : "-",
        project: item?.locking?.projectObject?.name || "-", 
        codeApartment: item?.apartment?.code || "-", 
        // periodReceive: item?.periodReceive || "-",
        totalValue: item?.locking?.totalValue
          ? `${formatNumber(Number(item?.locking?.totalValue))} VNĐ`
          : "0 VNĐ",
        amountPay: item?.totalCommission
          ? `${formatNumber(Number(item?.totalCommission))} VNĐ`
          : "0 VNĐ",
        amountReceive: item?.totalServiceFee
          ? `${formatNumber(Number(item?.totalServiceFee))} VNĐ`
          : "0 VNĐ",
      };
    });

    return { data: newData };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useSalesManagementDetail(search, startTime, endTime, employeeId) {

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey,  search, startTime, endTime, employeeId],
    queryFn: () => fetchSalesManagementDetail( search, startTime, endTime, employeeId),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  return {
    commissionAnalystData: data?.data,
    refetch,
    isLoading,
    isRefetching,
  };
}
